/**
 * V4.43 — Constantes de segmentation des apporteurs (Particuliers vs Pros).
 *
 * Source unique de vérité côté frontend pour les enums attendus par le backend.
 * Les clés correspondent EXACTEMENT aux valeurs acceptées par
 * `PATCH /api/apporteurs/{name}` (cf. APPORTEUR_CATEGORIES, ...).
 */

export const APPORTEUR_CATEGORIES = [
  { key: "professionnel", label: "Professionnel", short: "PRO", color: "#1D4ED8", bg: "#EFF6FF", border: "#BFDBFE" },
  { key: "particulier", label: "Particulier", short: "PARTICULIER", color: "#6D28D9", bg: "#F5F3FF", border: "#DDD6FE" },
  { key: "non_renseigne", label: "Non renseigné", short: "NON RENSEIGNÉ", color: "#64748B", bg: "#F1F5F9", border: "#CBD5E1" },
];

export const APPORTEUR_CATEGORY_BY_KEY = Object.fromEntries(
  APPORTEUR_CATEGORIES.map((c) => [c.key, c])
);

export const BUSINESS_ACTIVITIES = [
  { key: "agent_immobilier", label: "Agent immobilier" },
  { key: "mandataire_immobilier", label: "Mandataire immobilier" },
  { key: "constructeur", label: "Constructeur" },
  { key: "courtier_immobilier", label: "Courtier immobilier" },
  { key: "cgp", label: "CGP" },
  { key: "notaire", label: "Notaire" },
  { key: "expert_comptable", label: "Expert-comptable" },
  { key: "promoteur", label: "Promoteur" },
  { key: "marchand_de_biens", label: "Marchand de biens" },
  { key: "gestionnaire_patrimoine", label: "Gestionnaire de patrimoine" },
  { key: "autre", label: "Autre" },
];

export const BUSINESS_ACTIVITY_LABELS = Object.fromEntries(
  BUSINESS_ACTIVITIES.map((b) => [b.key, b.label])
);

export const PERSONAL_RELATIONS = [
  { key: "ancien_client", label: "Ancien client" },
  { key: "ami", label: "Ami" },
  { key: "famille", label: "Famille" },
  { key: "connaissance", label: "Connaissance" },
  { key: "client_en_cours", label: "Client en cours" },
  { key: "autre", label: "Autre" },
];

export const PERSONAL_RELATION_LABELS = Object.fromEntries(
  PERSONAL_RELATIONS.map((r) => [r.key, r.label])
);

/**
 * Petit badge compact pour les listes Apporteurs.
 * Utilisation : <ApporteurCategoryBadge category={a.category} />
 */
export function categoryBadgeStyle(category) {
  const c = APPORTEUR_CATEGORY_BY_KEY[category] || APPORTEUR_CATEGORY_BY_KEY.non_renseigne;
  return {
    label: c.short,
    bg: c.bg,
    color: c.color,
    border: c.border,
  };
}
